import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { EnrichmentStats, StatsRange } from '../../_shared/domain/stats.domain';
import { initialState } from './metrics.state';

/**
 * Metrics slice. Pure state transitions only; the fetch + poll live in the saga,
 * which dispatches these `load*` transitions as it progresses.
 */
const slice = createSlice({
  name: 'metrics',
  initialState,
  reducers: {
    /** A new period was asked for; the next `load*` transitions belong to it. */
    rangeChanged: (state, action: PayloadAction<StatsRange>) => {
      state.range = action.payload;
    },
    loadStarted: (state) => {
      // First load flips `loading` (skeletons); a poll refetch only flips `fetching`.
      if (state.stats === null) state.loading = true;
      state.fetching = true;
      state.error = false;
    },
    loadSucceeded: (state, action: PayloadAction<EnrichmentStats>) => {
      state.stats = action.payload;
      state.loading = false;
      state.fetching = false;
      state.error = false;
    },
    loadFailed: (state) => {
      state.loading = false;
      state.fetching = false;
      // Only surface the error state when there's no data to fall back on.
      if (state.stats === null) state.error = true;
    },
  },
});

export const metricsActions = slice.actions;
export const metricsReducer = slice.reducer;
